import { FIELD_TYPES } from '../constants/field-types';
import { uploadFile } from '../fields/file-upload/file-upload-actions';
import { loadInitialAppointmentData, getAvailabilityDates, getAvailabilitySlots } from '../fields/appointment/appointment-actions';
import { requestLogin, requestLogout } from '../fields/bookings-login-bar/login-bar-actions';
export const FIELD_ASYNC_ACTIONS = {
  [FIELD_TYPES.FILE_UPLOAD]: {
    uploadFile
  },
  [FIELD_TYPES.APPOINTMENT]: {
    getAvailabilityDates,
    getAvailabilitySlots
  },
  [FIELD_TYPES.QUIZ_FILE_UPLOAD]: {
    uploadFile
  },
  [FIELD_TYPES.SIGNATURE]: {
    uploadFile
  },
  [FIELD_TYPES.BOOKINGS_LOGIN_BAR]: {
    requestLogin,
    requestLogout
  }
};
export const INITIAL_DATA_LOADERS = {
  [FIELD_TYPES.APPOINTMENT]: loadInitialAppointmentData
};
//# sourceMappingURL=controller.js.map